import React from 'react';
import { useNavigate } from 'react-router-dom';

import Icon from 'components/DesignSystem/Icon';
import { FluxAboutDocument } from 'types/Flux/About/fluxAboutDocument';

import './index.scss';

export default function DocumentCard({ document, onEdit, onDelete }: {
  document: FluxAboutDocument,
  onEdit: (doc: FluxAboutDocument) => void,
  onDelete: (doc: FluxAboutDocument) => void,
}) {
  const navigate = useNavigate();

  return (
    <div className="about-mobile-card">
      <div className="about-mobile-card-summary">
        <p className="about-mobile-card-title">{document.titulo}</p>
        <span className="about-mobile-card-id">{`#${document.id}`}</span>
      </div>

      {document.descricao && (
        <p className="about-mobile-card-description">{document.descricao}</p>
      )}

      <dl className="about-mobile-card-meta">
        <div>
          <dt>Autor</dt>
          <dd>{document.autor || '—'}</dd>
        </div>
        <div>
          <dt>Ordem</dt>
          <dd>{document.ordem}</dd>
        </div>
      </dl>

      <div className="about-mobile-card-actions">
        <button
          type="button"
          className="about-mobile-card-action"
          onClick={() => navigate(`/flux/about?tab=${document.id}`)}
          aria-label="Visualizar documento"
        >
          <Icon iconType="open_in_new" size="small" />
          Visualizar
        </button>
        <button
          type="button"
          className="about-mobile-card-action"
          onClick={() => onEdit(document)}
          aria-label="Editar"
        >
          <Icon iconType="edit" size="small" />
          Editar
        </button>
        <button
          type="button"
          className="about-mobile-card-action danger"
          onClick={() => onDelete(document)}
          aria-label="Deletar"
        >
          <Icon iconType="trash" size="small" />
          Excluir
        </button>
      </div>
    </div>
  );
}
